import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../common/Logo';
import { Close, Menu, Search, User } from '../../Helpers/icons/Icons';

type PropsType = {
  isAuth: boolean;
  drawerAction: () => void;
};

export default function MobileBar({ isAuth, drawerAction }: PropsType) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  const searchable = location.pathname !== '/products';

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/products?keyword=${encodeURIComponent(keyword)}`);
    setOpen(false);
  };

  return (
    <div className='w-full border-b border-line bg-paper lg:hidden'>
      <div className='container-x'>
        <div className='flex h-[62px] items-center justify-between gap-2'>
          <button
            type='button'
            onClick={drawerAction}
            aria-label={`${t('menu')}`}
            className='-ml-2 flex h-10 w-10 items-center justify-center rounded-pill text-ink-800 transition-colors hover:bg-canvas'
          >
            <Menu size={22} />
          </button>

          <Logo size={34} />

          <div className='-mr-2 flex items-center'>
            {searchable && (
              <button
                type='button'
                onClick={() => setOpen(!open)}
                aria-label={`${t('search')}`}
                aria-expanded={open}
                className='flex h-10 w-10 items-center justify-center rounded-pill text-ink-800 transition-colors hover:bg-canvas'
              >
                {open ? <Close size={19} /> : <Search size={19} />}
              </button>
            )}
            <Link
              to={isAuth ? '/profile' : '/login'}
              aria-label={isAuth ? `${t('profile')}` : `${t('sign_in')}`}
              className='flex h-10 w-10 items-center justify-center rounded-pill text-ink-800 transition-colors hover:bg-canvas'
            >
              <User size={20} />
            </Link>
          </div>
        </div>

        {open && searchable && (
          <form onSubmit={onSearch} role='search' className='animate-fade-in pb-3'>
            <div className='flex h-11 items-center rounded-pill border border-line-strong bg-canvas px-3'>
              <Search size={17} className='flex-none text-ink-400' />
              <input
                autoFocus
                type='search'
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder={`${t('search')}…`}
                aria-label={`${t('search')}`}
                className='h-full w-full min-w-0 bg-transparent px-2 text-sm placeholder:text-ink-400 focus:outline-none'
              />
              <button type='submit' className='btn btn-ink btn-sm'>
                {t('search')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
